<template>
  <div class="nav__alert-bar">
    <div class="nav__alert-container">
      <span class="nav__alert-list">
        <span v-if="!isMobile" class="nav__alert-list-collapsed-text">
          <span class="icon icon--dangertriangle" aria-hidden="true">
            <danger-triangle />
          </span>
          <b>{{ summary.alert_count }} Drug Alerts </b>
          <template v-if="summary.first_alert_drug_types">
            newly reported for:
            {{ summary.first_alert_drug_types }}
          </template>
          <span class="nav__alert-expand-button">
            <a href="/drug-facts/#alerts" class="nav__alert-link"> See all </a>
          </span>
        </span>
        <span v-if="isMobile" class="nav__alert-list-collapsed-text">
          <span class="icon icon--dangertriangle" aria-hidden="true">
            <danger-triangle />
          </span>
          <b>{{ summary.alert_count }} Drug Alerts </b>
          <span class="nav__alert-expand-button">
            <a href="/drug-facts/#alerts" class="nav__alert-link"> See all </a>
          </span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import DangerTriangle from '@/components/svg/DangerTriangle.vue';

export default {
  name: 'AlertBar',
  components: { DangerTriangle },
  mounted() {
    this.checkIsMobile();
    window.addEventListener('resize', this.checkIsMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkIsMobile);
  },
  props: {
    summary: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isMobile: false,
    };
  },
  methods: {
    checkIsMobile() {
      if (window.innerWidth <= 720) {
        this.isMobile = true;
      }
    },
  },
};
</script>
